import { render, staticRenderFns } from "./BackupCodesArea.vue?vue&type=template&id=16a7bf4f&"
import script from "./BackupCodesArea.vue?vue&type=script&lang=js&"
export * from "./BackupCodesArea.vue?vue&type=script&lang=js&"
import style0 from "./BackupCodesArea.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BackupCodesArea.vue"
export default component.exports